import { sizes } from '@/ui/media'
import { DefaultTheme } from 'styled-components'

export const blueTheme: DefaultTheme = {
    grid: {
        gutter: 8,
        breakpoints: sizes
    },
    palette: {
        default: {
            main: '#f5f5f5',
            text: '#2C2C2C'
        },
        accent: {
            main: '#1caff7',
        },
        primary: {
            main: '#1caff7',
        },
        background: {
            primary: '#1caff7',
            default: '#f5f5f5',
        },
        text: {
            primary: "#fff",
            secondary: "#000",
            label: '#fff',
            input: 'rgba(0, 0, 0, 0.25)',
        }
    },
}

export default blueTheme
